import { gql } from 'graphql-request'

class EndUserMutations {
  updateEndUser = gql`
    mutation UpdateEndUser($where: EndUserWhereUniqueExtendedInput!, $data: EndUserUpdateInput!) {
      updateEndUser(where: $where, data: $data) {
        id
        user {
          displayName
          email
        }
        location {
          city
        }
        nbSharedExperiences
        nbPoints
        isSuspended
      }
    }
  `
}

const endUserMutations = new EndUserMutations()

export default endUserMutations
